import { useState, useEffect } from 'react';
import api from '../../services/api';

const TIPOS = [
  { v: 'desconto_pct', l: 'Desconto %' },
  { v: 'desconto_valor', l: 'Desconto R$' },
  { v: 'frete_gratis', l: 'Frete Grátis' }
];

const APLICAR = [
  { v: 'carrinho', l: 'Carrinho inteiro' },
  { v: 'produto', l: 'Produto específico' }
];

const vazio = {
  codigo: '', nome: '', descricao: '',
  tipo: 'desconto_pct', aplicar_em: 'carrinho', produto_id: '',
  valor: '', pedido_minimo: '', usos_max: '', validade: '', ativo: 1
};

export default function Cupons() {
  const [cupons, setCupons] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [form, setForm] = useState(vazio);
  const [editando, setEditando] = useState(null);
  const [toast, setToast] = useState('');
  const [mostrarForm, setMostrarForm] = useState(false);

  const carregar = async () => {
    try {
      const [c, p] = await Promise.all([
        api.get('/cupons'),
        api.get('/produtos/todos')
      ]);
      setCupons(c.data);
      setProdutos(p.data);
    } catch { showToast('❌ Erro ao carregar'); }
  };

  useEffect(() => { carregar(); }, []);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 2500);
  };

  const abrirNovo = () => {
    setForm(vazio);
    setEditando(null);
    setMostrarForm(true);
  };

  const abrirEdicao = (c) => {
    setEditando(c);
    setForm({
      codigo: c.codigo || '',
      nome: c.nome || '',
      descricao: c.descricao || '',
      tipo: c.tipo || 'desconto_pct',
      aplicar_em: c.aplicar_em || 'carrinho',
      produto_id: c.produto_id || '',
      valor: c.valor || '',
      pedido_minimo: c.pedido_minimo || '',
      usos_max: c.usos_max || '',
      validade: c.validade ? c.validade.slice(0, 10) : '',
      ativo: c.ativo ? 1 : 0
    });
    setMostrarForm(true);
  };

  const cancelar = () => {
    setEditando(null);
    setForm(vazio);
    setMostrarForm(false);
  };

  const salvar = async () => {
    if (!form.codigo) return showToast('⚠️ Informe o código');
    if (form.tipo !== 'frete_gratis' && !form.valor) return showToast('⚠️ Informe o valor');
    if (form.aplicar_em === 'produto' && !form.produto_id) return showToast('⚠️ Selecione o produto');

    const payload = {
      ...form,
      valor: parseFloat(form.valor) || 0,
      pedido_minimo: form.pedido_minimo ? parseFloat(form.pedido_minimo) : 0,
      usos_max: form.usos_max ? parseInt(form.usos_max) : null,
      produto_id: form.aplicar_em === 'produto' ? parseInt(form.produto_id) : null,
      validade: form.validade || null
    };

    try {
      if (editando) {
        await api.put(`/cupons/${editando.id}`, payload);
        showToast('✅ Atualizado!');
      } else {
        await api.post('/cupons', payload);
        showToast('✅ Cupom criado!');
      }
      cancelar();
      carregar();
    } catch (e) {
      showToast(e.response?.data?.erro || '❌ Erro ao salvar');
    }
  };

  const remover = async (c) => {
    if (!window.confirm(`Remover cupom "${c.codigo}"?`)) return;
    try {
      await api.delete(`/cupons/${c.id}`);
      showToast('🗑️ Removido');
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const toggleAtivo = async (c) => {
    try {
      await api.patch(`/cupons/${c.id}/toggle`);
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const labelTipo = (t) => TIPOS.find(x => x.v === t)?.l || t;

  const descricaoValor = (c) => {
    if (c.tipo === 'frete_gratis') return 'Frete Grátis';
    if (c.tipo === 'desconto_pct') return `${parseFloat(c.valor)}% OFF`;
    return `R$ ${parseFloat(c.valor).toFixed(2)} OFF`;
  };

  return (
    <div style={{ padding: 20, color: '#fff', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ margin: 0 }}>🎟️ Cupons</h1>
        {!mostrarForm && (
          <button onClick={abrirNovo} style={btnPrimary}>+ Novo Cupom</button>
        )}
      </div>

      {mostrarForm && (
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>{editando ? '✏️ Editar Cupom' : '➕ Novo Cupom'}</h3>

          <div style={grid2}>
            <div>
              <label style={lbl}>Código *</label>
              <input style={inp} value={form.codigo}
                onChange={e => setForm({ ...form, codigo: e.target.value.toUpperCase() })}
                placeholder="EX: BEMVINDO10" />
            </div>
            <div>
              <label style={lbl}>Nome (interno)</label>
              <input style={inp} value={form.nome}
                onChange={e => setForm({ ...form, nome: e.target.value })}
                placeholder="Ex: Promo de boas-vindas" />
            </div>
          </div>

          <label style={lbl}>Descrição (opcional)</label>
          <textarea style={{ ...inp, minHeight: 60 }} value={form.descricao}
            onChange={e => setForm({ ...form, descricao: e.target.value })}
            placeholder="Descrição do cupom" />

          <div style={grid2}>
            <div>
              <label style={lbl}>Tipo *</label>
              <select style={inp} value={form.tipo}
                onChange={e => setForm({ ...form, tipo: e.target.value })}>
                {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
              </select>
            </div>

            {form.tipo !== 'frete_gratis' && (
              <div>
                <label style={lbl}>Aplicar em *</label>
                <select style={inp} value={form.aplicar_em}
                  onChange={e => setForm({ ...form, aplicar_em: e.target.value })}>
                  {APLICAR.map(a => <option key={a.v} value={a.v}>{a.l}</option>)}
                </select>
              </div>
            )}
          </div>

          {form.aplicar_em === 'produto' && form.tipo !== 'frete_gratis' && (
            <>
              <label style={lbl}>Produto *</label>
              <select style={inp} value={form.produto_id}
                onChange={e => setForm({ ...form, produto_id: e.target.value })}>
                <option value="">-- Selecione --</option>
                {produtos.map(p => (
                  <option key={p.id} value={p.id}>{p.nome} — R$ {parseFloat(p.preco).toFixed(2)}</option>
                ))}
              </select>
            </>
          )}

          {form.tipo !== 'frete_gratis' && (
            <div style={grid2}>
              <div>
                <label style={lbl}>
                  Valor * {form.tipo === 'desconto_pct' ? '(%)' : '(R$)'}
                </label>
                <input style={inp} type="number" step="0.01" value={form.valor}
                  onChange={e => setForm({ ...form, valor: e.target.value })} />
              </div>
              <div>
                <label style={lbl}>Pedido Mínimo (R$)</label>
                <input style={inp} type="number" step="0.01" value={form.pedido_minimo}
                  onChange={e => setForm({ ...form, pedido_minimo: e.target.value })} />
              </div>
            </div>
          )}

          <div style={grid2}>
            <div>
              <label style={lbl}>Usos Máximos (vazio = ilimitado)</label>
              <input style={inp} type="number" value={form.usos_max}
                onChange={e => setForm({ ...form, usos_max: e.target.value })} />
            </div>
            <div>
              <label style={lbl}>Validade (opcional)</label>
              <input style={inp} type="date" value={form.validade}
                onChange={e => setForm({ ...form, validade: e.target.value })} />
            </div>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
            <input type="checkbox" checked={!!form.ativo}
              onChange={e => setForm({ ...form, ativo: e.target.checked ? 1 : 0 })} />
            Ativo
          </label>

          <div style={{ display: 'flex', gap: 10, marginTop: 15 }}>
            <button onClick={salvar} style={btnPrimary}>💾 Salvar</button>
            <button onClick={cancelar} style={btnSecondary}>Cancelar</button>
          </div>
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        {cupons.length === 0 && !mostrarForm && (
          <div style={{ ...card, textAlign: 'center', color: '#888' }}>
            Nenhum cupom cadastrado. Clique em "+ Novo Cupom".
          </div>
        )}
        {cupons.map(c => (
          <div key={c.id} style={{ ...card, opacity: c.ativo ? 1 : 0.5 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 20, fontWeight: 'bold', color: '#f5c445' }}>
                  {c.codigo}
                </div>
                {c.nome && <div style={{ color: '#ccc', marginTop: 4 }}>{c.nome}</div>}
                <div style={{ marginTop: 8, fontSize: 14 }}>
                  <span style={badge}>{labelTipo(c.tipo)}</span>
                  <span style={{ ...badge, background: '#2a5' }}>{descricaoValor(c)}</span>
                  {c.aplicar_em === 'produto' && c.produto_nome && (
                    <span style={{ ...badge, background: '#557' }}>📦 {c.produto_nome}</span>
                  )}
                </div>
                <div style={{ marginTop: 8, fontSize: 13, color: '#888' }}>
                  Usos: {c.usos_atual}{c.usos_max ? `/${c.usos_max}` : ' (ilimitado)'}
                  {c.pedido_minimo > 0 && ` • Mín: R$ ${parseFloat(c.pedido_minimo).toFixed(2)}`}
                  {c.validade && ` • Válido até: ${new Date(c.validade).toLocaleDateString('pt-BR')}`}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                <button onClick={() => toggleAtivo(c)} style={c.ativo ? btnWarn : btnPrimary}>
                  {c.ativo ? '⏸️ Desativar' : '▶️ Ativar'}
                </button>
                <button onClick={() => abrirEdicao(c)} style={btnSecondary}>✏️ Editar</button>
                <button onClick={() => remover(c)} style={btnDanger}>🗑️</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {toast && (
        <div style={{
          position: 'fixed', bottom: 20, right: 20, background: '#333',
          color: '#fff', padding: '12px 20px', borderRadius: 8, zIndex: 999
        }}>{toast}</div>
      )}
    </div>
  );
}

const card = { background: '#212121', padding: 20, borderRadius: 10, marginBottom: 12, border: '1px solid #404040' };
const lbl = { display: 'block', marginTop: 10, marginBottom: 4, fontSize: 13, color: '#ccc' };
const inp = { width: '100%', padding: 10, background: '#1a1a1a', border: '1px solid #404040', borderRadius: 6, color: '#fff', boxSizing: 'border-box' };
const grid2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 4 };
const btnPrimary = { background: '#d4a017', color: '#000', border: 'none', padding: '10px 18px', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' };
const btnSecondary = { background: '#404040', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: 6, cursor: 'pointer' };
const btnDanger = { background: '#b33', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 6, cursor: 'pointer' };
const btnWarn = { background: '#888', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: 6, cursor: 'pointer' };
const badge = { display: 'inline-block', background: '#404040', color: '#fff', padding: '3px 10px', borderRadius: 12, fontSize: 12, marginRight: 6 };
